var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 12.5362H33.3333C32.9211 12.535 32.5262 12.3712 32.2347 12.0807C31.9433 11.7901 31.779 11.3964 31.7778 10.9855V6.33331L38 12.5362Z",
    fill: "#AAC4DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 12.5362V40.4493C37.9988 40.8602 37.8345 41.2539 37.543 41.5444C37.2516 41.835 36.8566 41.9988 36.4444 42H11.5556C11.1434 41.9988 10.7484 41.835 10.457 41.5444C10.1655 41.2539 10.0012 40.8602 10 40.4493V7.88404C10.0012 7.47314 10.1655 7.07942 10.457 6.78887C10.7484 6.49831 11.1434 6.33454 11.5556 6.33331H31.7778V10.9855C31.779 11.3964 31.9433 11.7901 32.2347 12.0807C32.5262 12.3712 32.9212 12.535 33.3333 12.5362H38Z",
    fill: "#EDF7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7333 11.1406H21.2",
    stroke: "#4C5B66",
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7333 13.0014H25.4",
    stroke: "#4C5B66",
    strokeWidth: 1.86087,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8889 22.616H32.5555",
    stroke: "#59A5EE",
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8889 20.2899H33.3333",
    stroke: "#59A5EE",
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8889 17.9637H31.7777",
    stroke: "#59A5EE",
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8889 20.2899H19.3333",
    stroke: "#59A5EE",
    strokeWidth: 5.58261,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8889 28.0435H32.5555",
    stroke: "#4C5B66",
    strokeOpacity: 0.4,
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8889 30.3696H32.5555",
    stroke: "#4C5B66",
    strokeOpacity: 0.4,
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8889 32.6957H33.3333",
    stroke: "#4C5B66",
    strokeOpacity: 0.4,
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8889 35.0218H31",
    stroke: "#4C5B66",
    strokeOpacity: 0.4,
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8889 37.3478H32.5555",
    stroke: "#4C5B66",
    strokeOpacity: 0.4,
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0667 12.5362H33.3333C32.9207 12.5362 32.525 12.3728 32.2333 12.082C31.9416 11.7912 31.7777 11.3968 31.7777 10.9855V6.33331",
    stroke: "#4C5B66",
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38 40.4493C38 40.8605 37.8361 41.255 37.5444 41.5458C37.2527 41.8366 36.857 42 36.4444 42H11.5556C11.143 42 10.7473 41.8366 10.4556 41.5458C10.1639 41.255 10 40.8605 10 40.4493V7.88404C10 7.47276 10.1639 7.07833 10.4556 6.78751C10.7473 6.49669 11.143 6.33331 11.5556 6.33331H31.7778L38 12.5362V40.4493Z",
    stroke: "#4C5B66",
    strokeWidth: 1.86087,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.5b0c71389eec47d1159e246472462e87.svg";
export { ForwardRef as ReactComponent };